import * as api from '../../services/market'
import lodash from 'lodash'

export const FETCH_MARKETS= 'FETCH_MARKETS';
export const FETCH_MARKETGOODS= 'FETCH_MARKETGOODS';
export const FETCH_MARKETPURCHASES= 'FETCH_MARKETPURCHASES';




export const fetchMarkets = (params, pagination, sort, extra) => {

    return {
        type: FETCH_MARKETS,
        payload: {
            promise: api.findMarkets(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: lodash.omit(params, 'ownership'),
            sort: sort,
            extra: extra
        }
    };
};
export const fetchMarketGoods = (params, pagination, sort, extra) => {

    return {
        type: FETCH_MARKETGOODS,
        payload: {
            promise: api.findMarketGoods(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    };
};
export const fetchMarketPurchases= (params, pagination, sort, extra) => {

    return {
        type: FETCH_MARKETPURCHASES,
        payload: {
            promise: api.findMarketPurchases(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    };
};



// WEBPACK FOOTER //
// ./src/redux/actions/market.js